<app-semester-select
  [showInAttendanceOnly]="true"
  [showInKindergarten]="true"
  (onClick)="onSemesterSelect($event)">
</app-semester-select>
